export const limitMobilePaddings = (value) => {
  if (value > 20) return '20px';
  return value + 'px';
};
